
export const APPRAISAL_PROGRAM = 'yiT00XKrrHP'; // or a new program if preferred

export const APPRAISAL_PROGRAM_STAGES = {
  MID_YEAR: 'xbEyVHbXlGK',
  YEAR_END: 'wEsUvf2luKr',
};

export const DATA_ELEMENTS = {
  APPRAISAL_STATUS: 'cA753DO19RI',
  EMPLOYEE_SELF_RATING_TASK: 'CAx2MUxKaAl',
  EMPLOYEE_SELF_RATING_BEHAVIOURAL: 'FI5gjGSagB5',
  EMPLOYEE_COMMENTS: 'toGkgVQbRbg',
  MANAGER_RATING_TASK: 'UKDk6cPVEha',
  MANAGER_RATING_BEHAVIOURAL: 'pAGDYpY5X6f',
  MANAGER_COMMENTS: 'XjGPqk429bR',
};

export const OBJECTIVE_APPRAISAL_DE = {
  SELF_RATING: 'Twk8uxfdOmT',      
  SELF_COMMENTS: 'fjIgDhvpmIK',      
};

// Option codes (values stored in the data element)
export const APPRAISAL_STATUSES = {
  DRAFT: 'draft',        // ← lowercase code
  SUBMITTED: 'submitted',
  REVIEWED: 'reviewed',
  FINALIZED: 'finalized',
  RETURNED: 'returned', 
};